@if (embedToken && powerbifilters) {
  <app-powerbi-page style="height: 100%; width: 100%" [token]="embedToken"
    [reportid]="getReportModal().reportId" [pageid]="getReportModal().pageId" [groupid]="getReportModal().groupId"
  [filters]="powerbifilters"></app-powerbi-page>
}